import { useModalForms } from '../../../modalForms/modalFormsContext/';
import { CouponValidityProvider } from './couponValidityContext';
import { InputDatesContainer } from './inputDatesContainer';
import { ButtonNextForm } from './buttonNextForm';
import { InputNoEndDate } from './inputNoEndDate';

import { Container } from './style';


export function CouponValidity() {
    const { changeVisibleContent } = useModalForms()

    return(
        <Container changeVisibleContent={changeVisibleContent}>
            
            <CouponValidityProvider>

                <InputDatesContainer />

                <InputNoEndDate />

                <ButtonNextForm />

            </CouponValidityProvider>

        </Container>
    )
}
